import React from 'react'

import Main from './Main'

const MainComponent = ({ children, className }) => <Main className={className}>{children}</Main>

export default MainComponent
